import { createGetOptionsApi } from "../index";

export const getDayOfWeekOptions = createGetOptionsApi("/Lookup/DayOfWeek", "dayOfWeek", 5);
